

























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { CajaChica } from "@/typings/store/plugins/easyFirestore/cajaChicas";
import { ItemsTablaCajaChicas } from "@/typings/components/cajaChicas/tabla";
import "@/helpers/extensions";

@Component
export default class TablaCajaChicas extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly cajaChicas!: Array<CajaChica>;
  @Prop() readonly usuario!: string;

  options = { page: 1, itemsPerPage: 7, pageCount: 0 };
  headerProps = { sortIcon: "mdi-chevron-down" };
  footerProps = { itemsPerPageOptions: [5, 10, 15, 25], showFirstLastPage: true, showCurrentPage: true, class: "tabla-caja-gerencial__footer" };

  get headers(): HeadersDataTable {
    return [
      { text: "N°", value: "numero" },
      { text: "Fecha", value: "fecha" },
      { text: "Rut Prov", value: "rutProveedor" },
      { text: "Nombre Prov", value: "nombreProveedor" },
      { text: "Acción", value: "accion" },
      { text: "Ingresos", value: "ingreso" },
      { text: "Egresos", value: "egreso" },
      { text: "Documento", value: "documento" },
      { text: "Concepto", value: "concepto" },
      { text: "Comprobante", value: "tieneComprobante", sortable: true, width: "140" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Acciones", value: "opciones", sortable: false, align: "end", width: "96" },
    ];
  }

  get items(): ItemsTablaCajaChicas {
    return this.cajaChicas.map((cajaChica) => {
      const ingreso = (parseInt(cajaChica.ingreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const egreso = (parseInt(cajaChica.egreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const archivo = cajaChica.archivo;
      const tieneComprobante = !!(archivo && typeof archivo === "object" && Object.keys(archivo).length > 0);
      return {
        numero: cajaChica.numero,
        fecha: cajaChica.fecha,
        saldoActual: cajaChica.saldoActual,
        rutProveedor: cajaChica.rutProveedor,
        nombreProveedor: cajaChica.nombreProveedor,
        accion: cajaChica.accion,
        ingreso,
        egreso,
        documento: cajaChica.documento,
        concepto: cajaChica.concepto,
        descripcion: cajaChica.descripcion,
        tieneComprobante,
        data: cajaChica,
      };
    });
  }

  getRowClass(item: { numero: number }): string {
    return `tabla-caja-gerencial__row-num-${item.numero}`;
  }

  onTableClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest("td:last-child") || target.closest("button") || target.closest(".v-menu")) return;
    const tr = target.closest("tbody tr");
    if (!tr) return;
    const match = tr.className.match(/tabla-caja-gerencial__row-num-(\d+)/);
    if (!match) return;
    const numero = parseInt(match[1], 10);
    const item = this.items.find((i) => i.numero === numero);
    if (item && item.data) this.onAbrirInfo(item.data);
  }

  @Emit("abrir-info")
  onAbrirInfo(cajaChica: CajaChica): CajaChica {
    return cajaChica;
  }

  @Emit("abrir-editar")
  onAbrirEditar(cajaChica: CajaChica): CajaChica {
    return cajaChica;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(cajaChica: CajaChica): CajaChica {
    return cajaChica;
  }
}
